var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import Immutable from 'seamless-immutable';
import { createAction, handleActions } from 'redux-actions';
import { createSelector } from 'reselect';
import { buildDefaultHesiNGExamResultFilter, buildDefaultStudentHesiNGExamResultFilter, buildEmptyRowsState, buildDefaultHesiNGExamResultDateFilter } from 'services/filter.service';
import { AppConstant } from 'constants/app.constant';
import { cohortListItemsFilterConfig, hadCohortStudentTableFilterConfig, psExamsStudentTableFilterConfig } from 'constants/filter.constant';
import { ASSIGNMENT_DUE_MENU_SEMESTER } from 'reports/cw/constants/cw.constant';
var baseTableFilter = {
    searchKeyword: '',
    assignmentDueMenuCheckedKey: '',
    assignmentTypeMenuCheckedKeys: [],
    filteredGradedOnly: true
};
var initialState = Immutable({
    hadCohortStudentTableRowsState: buildEmptyRowsState(hadCohortStudentTableFilterConfig),
    hadCohortListItemsState: buildEmptyRowsState(cohortListItemsFilterConfig),
    psCohortListItemsState: buildEmptyRowsState(cohortListItemsFilterConfig),
    dpCohortListItemsState: buildEmptyRowsState(cohortListItemsFilterConfig),
    psExamsStudentTableFilterConfig: psExamsStudentTableFilterConfig,
    hesiNGExamResultFilter: buildDefaultHesiNGExamResultFilter(),
    studentHesiNGExamResultFilter: buildDefaultStudentHesiNGExamResultFilter(),
    hesiNGExamResultDateFilter: buildDefaultHesiNGExamResultDateFilter(),
    hadCohortStudentTableSearch: '',
    cwEngagementAssignmentTypeDropdownId: '',
    cwAssignmentEngagementTableSearch: '',
    cwStudentEngagementTableSearch: '',
    cwGradebookTableSearch: '',
    cwStudentDetailTableSearch: '',
    cwAssignmentSummaryTableFilter: baseTableFilter,
    cwStudentAssignmentSummaryTableFilter: baseTableFilter,
    cwStudentAssignmentEngagementTableFilter: baseTableFilter,
    cwInsStudentDetailAssignmentSummaryFilter: {
        searchKeyword: '',
        assignmentTypeMenuCheckedKeys: [],
        assignmentDueMenuCheckedKey: ASSIGNMENT_DUE_MENU_SEMESTER.key,
        filteredGradedOnly: true
    },
    cwInsStudentDetailAssignmentEngagementFilter: {
        searchKeyword: '',
        assignmentTypeMenuCheckedKeys: [],
        assignmentDueMenuCheckedKey: ASSIGNMENT_DUE_MENU_SEMESTER.key,
        filteredGradedOnly: true
    },
    cwInsStudentDetail: {
        selectedStudentId: '',
        activeTabIndex: 0
    },
    cwAssignmentSummaryTableSearch: ''
});
var resetState = createAction('FILTER/RESET_STATE');
var restoreState = createAction('FILTER/RESTORE_STATE');
var setHADCohortStudentTableRowsState = createAction('FILTER/SET_HAD_COHORT_STUDENT_TABLE_ROWS_STATE');
var setHADCohortListItemsState = createAction('FILTER/SET_HAD_COHORT_LIST_ITEMS_STATE');
var setPSCohortListItemsState = createAction('FILTER/SET_PS_COHORT_LIST_ITEMS_STATE');
var setDPCohortListItemsState = createAction('FILTER/SET_DP_COHORT_LIST_ITEMS_STATE');
var setHesiNGExamResultFilter = createAction('FILTER/SET_HESI_NG_EXAM_RESULT_FILTER');
var setHesiNGExamResultDateFilter = createAction('FILTER/SET_HESI_NG_EXAM_RESULT_DATE_FILTER');
var setStudentHesiNGExamResultFilter = createAction('FILTER/SET_STUDENT_HESI_NG_EXAM_RESULT_FILTER');
var setHADCohortStudentTableSearch = createAction('FILTER/SET_HAD_COHORT_STUDENT_TABLE_SEARCH');
var setCWInsStudentDetail = createAction('FILTER/SET_INS_STUDENT_DETAIL');
var setCWInsStudentDetailAssignmentSummaryFilter = createAction('FILTER/SET_INS_STUDENT_DETAIL_ASSIGNMENT_SUMMARY_FILTER');
var setCWInsStudentDetailAssignmentEngagementFilter = createAction('FILTER/SET_INS_STUDENT_DETAIL_ASSIGNMENT_ENGAGEMENT_FILTER');
var setCWEngagementAssignmentTypeDropdownId = createAction('FILTER/SET_CW_ENGAGEMENT_ASSIGNMENT_TYPE_DROPDOWN_ID');
var setCWAssignmentEngagementTableSearch = createAction('FILTER/SET_CW_ASSIGNMENT_ENGAGEMENT_TABLE_SEARCH');
var setCWStudentEngagementTableSearch = createAction('FILTER/SET_CW_STUDENT_ENGAGEMENT_TABLE_SEARCH');
var setCWGradebookTableSearch = createAction('FILTER/SET_CW_GRADEBOOK_TABLE_SEARCH');
var setCWAssignmentSummaryTableFilter = createAction('FILTER/SET_CW_ASSIGNMENT_SUMMARY_TABLE_FILTER');
var setCWStudentAssignmentSummaryTableFilter = createAction('FILTER/SET_CW_STUDENT_ASSIGNMENT_SUMMARY_TABLE_FILTER');
var setCWStudentAssignmentEngagementTableFilter = createAction('FILTER/SET_CW_STUDENT_ASSIGNMENT_ENGAGEMENT_TABLE_FILTER');
var setCwAssignmentSummaryTableSearch = createAction('FILTER/SET_CW_ASSIGNMENT_SUMMARY_TABLE_SEARCH');
var setPSExamsStudentTableFilterConfig = createAction('FILTER/SET_PS_EXAMS_STUDENT_TABLE_FILTER_CONFIG');
var actions = {
    resetState: resetState,
    restoreState: restoreState,
    setHADCohortStudentTableRowsState: setHADCohortStudentTableRowsState,
    setHADCohortListItemsState: setHADCohortListItemsState,
    setPSCohortListItemsState: setPSCohortListItemsState,
    setDPCohortListItemsState: setDPCohortListItemsState,
    setHesiNGExamResultFilter: setHesiNGExamResultFilter,
    setHesiNGExamResultDateFilter: setHesiNGExamResultDateFilter,
    setStudentHesiNGExamResultFilter: setStudentHesiNGExamResultFilter,
    setHADCohortStudentTableSearch: setHADCohortStudentTableSearch,
    setCWInsStudentDetail: setCWInsStudentDetail,
    setCWInsStudentDetailAssignmentSummaryFilter: setCWInsStudentDetailAssignmentSummaryFilter,
    setCWInsStudentDetailAssignmentEngagementFilter: setCWInsStudentDetailAssignmentEngagementFilter,
    setCWEngagementAssignmentTypeDropdownId: setCWEngagementAssignmentTypeDropdownId,
    setCWAssignmentEngagementTableSearch: setCWAssignmentEngagementTableSearch,
    setCWStudentEngagementTableSearch: setCWStudentEngagementTableSearch,
    setCWGradebookTableSearch: setCWGradebookTableSearch,
    setCWAssignmentSummaryTableFilter: setCWAssignmentSummaryTableFilter,
    setCWStudentAssignmentSummaryTableFilter: setCWStudentAssignmentSummaryTableFilter,
    setCWStudentAssignmentEngagementTableFilter: setCWStudentAssignmentEngagementTableFilter,
    setCwAssignmentSummaryTableSearch: setCwAssignmentSummaryTableSearch,
    setPSExamsStudentTableFilterConfig: setPSExamsStudentTableFilterConfig
};
var reducer = handleActions((_a = {},
    _a[actions.resetState] = function (state) { return (__assign(__assign({}, initialState), { hadCohortListItemsState: state.hadCohortListItemsState, psCohortListItemsState: state.psCohortListItemsState })); },
    _a[actions.restoreState] = function (state, _a) {
        var payload = _a.payload;
        return state.merge(payload);
    },
    _a[actions.setHADCohortStudentTableRowsState] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'hadCohortStudentTableRowsState', payload);
    },
    _a[actions.setHADCohortListItemsState] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'hadCohortListItemsState', payload);
    },
    _a[actions.setPSCohortListItemsState] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'psCohortListItemsState', payload);
    },
    _a[actions.setDPCohortListItemsState] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'dpCohortListItemsState', payload);
    },
    _a[actions.setHADCohortStudentTableSearch] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'hadCohortStudentTableSearch', payload);
    },
    _a[actions.setCWInsStudentDetail] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'cwInsStudentDetail', payload);
    },
    _a[actions.setCWInsStudentDetailAssignmentSummaryFilter] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'cwInsStudentDetailAssignmentSummaryFilter', payload);
    },
    _a[actions.setCWInsStudentDetailAssignmentEngagementFilter] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'cwInsStudentDetailAssignmentEngagementFilter', payload);
    },
    _a[actions.setCWEngagementAssignmentTypeDropdownId] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'cwEngagementAssignmentTypeDropdownId', payload);
    },
    _a[actions.setCWAssignmentEngagementTableSearch] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'cwAssignmentEngagementTableSearch', payload);
    },
    _a[actions.setCWStudentEngagementTableSearch] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'cwStudentEngagementTableSearch', payload);
    },
    _a[actions.setCWGradebookTableSearch] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'cwGradebookTableSearch', payload);
    },
    _a[actions.setCWAssignmentSummaryTableFilter] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'cwAssignmentSummaryTableFilter', payload);
    },
    _a[actions.setCWStudentAssignmentSummaryTableFilter] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'cwStudentAssignmentSummaryTableFilter', payload);
    },
    _a[actions.setCWStudentAssignmentEngagementTableFilter] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'cwStudentAssignmentEngagementTableFilter', payload);
    },
    _a[actions.setCwAssignmentSummaryTableSearch] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'cwAssignmentSummaryTableSearch', payload);
    },
    _a[actions.setHesiNGExamResultFilter] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'hesiNGExamResultFilter', payload);
    },
    _a[actions.setHesiNGExamResultDateFilter] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'hesiNGExamResultDateFilter', payload);
    },
    _a[actions.setStudentHesiNGExamResultFilter] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'studentHesiNGExamResultFilter', payload);
    },
    _a[actions.setPSExamsStudentTableFilterConfig] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'psExamsStudentTableFilterConfig', payload);
    },
    _a), initialState);
var getFilterState = function (state) { return state[AppConstant.reduxResources.FILTER_STATE]; };
var selectors = {
    getHADCohortStudentTableRowsState: createSelector(getFilterState, function (state) { return state.hadCohortStudentTableRowsState; }),
    getHADCohortListItemsState: createSelector(getFilterState, function (state) { return state.hadCohortListItemsState; }),
    getPSCohortListItemsState: createSelector(getFilterState, function (state) { return state.psCohortListItemsState; }),
    getDPCohortListItemsState: createSelector(getFilterState, function (state) { return state.dpCohortListItemsState; }),
    getHADCohortStudentTableSearch: createSelector(getFilterState, function (state) { return state.hadCohortStudentTableSearch; }),
    getHesiNGExamResultFilter: createSelector(getFilterState, function (state) { return state.hesiNGExamResultFilter; }),
    getHesiNGExamResultDateFilter: createSelector(getFilterState, function (state) { return state.hesiNGExamResultDateFilter; }),
    getStudentHesiNGExamResultFilter: createSelector(getFilterState, function (state) { return state.studentHesiNGExamResultFilter; }),
    getCWInsStudentDetail: createSelector(getFilterState, function (state) { return Immutable.asMutable(state.cwInsStudentDetail || {}, { deep: true }); }),
    getCWInsStudentDetailAssignmentSummaryFilter: createSelector(getFilterState, function (state) { return Immutable.asMutable(state.cwInsStudentDetailAssignmentSummaryFilter || {}, { deep: true }); }),
    getCWInsStudentDetailAssignmentEngagementFilter: createSelector(getFilterState, function (state) {
        return Immutable.asMutable(state.cwInsStudentDetailAssignmentEngagementFilter || {}, { deep: true });
    }),
    getCWEngagementAssignmentTypeDropdownId: createSelector(getFilterState, function (state) { return state.cwEngagementAssignmentTypeDropdownId; }),
    getCWAssignmentEngagementTableSearch: createSelector(getFilterState, function (state) { return state.cwAssignmentEngagementTableSearch; }),
    getCWStudentEngagementTableSearch: createSelector(getFilterState, function (state) { return state.cwStudentEngagementTableSearch; }),
    getCWAssignmentSummaryTableFilter: createSelector(getFilterState, function (state) { return Immutable.asMutable(state.cwAssignmentSummaryTableFilter || {}, { deep: true }); }),
    getCWStudentAssignmentSummaryTableFilter: createSelector(getFilterState, function (state) { return Immutable.asMutable(state.cwStudentAssignmentSummaryTableFilter || {}, { deep: true }); }),
    getCWStudentAssignmentEngagementTableFilter: createSelector(getFilterState, function (state) { return Immutable.asMutable(state.cwStudentAssignmentEngagementTableFilter || {}, { deep: true }); }),
    getCWGradebookTableSearch: createSelector(getFilterState, function (state) { return state.cwGradebookTableSearch; }),
    getCWStudentDetailTableSearch: createSelector(getFilterState, function (state) { return state.cwStudentDetailTableSearch; }),
    getCWAssignmentSummaryTableSearch: createSelector(getFilterState, function (state) { return state.cwAssignmentSummaryTableSearch; }),
    getPSExamsStudentTableFilterConfig: createSelector(getFilterState, function (state) { return state.psExamsStudentTableFilterConfig; })
};
export { actions as filterActions, reducer as filterReducer, selectors as filterSelectors };
export { initialState as filterInitialState };
